module.exports = __webpack_public_path__ + "media/Slide15.163ca941.mp3";